import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { API_CONFIG } from '../config/api';

interface ModuleProgress {
  currentStep: number;
  completed: boolean;
}

const useModuleProgress = (moduleId: string) => {
  const { user, token } = useAuth();
  const [currentStep, setCurrentStep] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const response = await fetch(`${API_CONFIG.ENDPOINTS.MODULE_PROGRESS}/${moduleId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        });

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.data) {
            setCurrentStep(data.data.currentStep);
            setIsCompleted(data.data.completed || false);
          }
        }
      } catch (error) {

      } finally {
        setIsLoading(false);
      }
    };

    if (user && token) {
      fetchProgress();
    } else {
      setIsLoading(false);
    }
  }, [user, token, moduleId]);

  const saveProgress = async (step: number, completed: boolean = false) => {
    if (!user || !token) return;

    try {
      const response = await fetch(`${API_CONFIG.ENDPOINTS.MODULE_PROGRESS}/${moduleId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ currentStep: step, completed })
      });
      
      if (response.ok) {
        setCurrentStep(step);
        setIsCompleted(completed); // Update completion status in local state
      }
    } catch (error) {

    }
  };

  return {
    currentStep,
    setCurrentStep,
    isLoading,
    saveProgress,
    isCompleted // Expose completion status to components
  };
};

export default useModuleProgress;
